import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import api from "../lib/api";
import "./UnregisteredList.css"; 

const UnregisteredList = () => {
    const { eventId } = useParams();
    const navigate = useNavigate();

    const [event, setEvent] = useState(null);
    const [unregisteredParticipants, setUnregisteredParticipants] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchUnregisteredList = async () => {
            if (!eventId) {
                setError("イベントIDが見つかりません。");
                setLoading(false);
                return;
            }

            try {
                const eventRes = await api.get(`/events/${eventId}/`);
                setEvent(eventRes.data);

                const resultsRes = await api.get(`/events/${eventId}/results/`);
                const participants = resultsRes.data;

                
                const unregistered = participants.filter(
                    (p) => p.is_participating === null
                );
                
                setUnregisteredParticipants(unregistered);
                setLoading(false);

            } catch (err) {
                console.error("未登録者リストの取得に失敗しました:", err);
                if (err.response && err.response.status === 403) {
                    setError("アクセス権限がありません。");
                } else if (err.response && err.response.status === 500) {
                    setError("サーバーエラーが発生しました。");
                } else {
                    setError("データの取得中にエラーが発生しました。");
                }
                setLoading(false);
            }
        };

        fetchUnregisteredList();
    }, [eventId]);

    const handlePrint = () => {
      window.print();
    };

    if (loading) {
        return <div className="container">ロード中...</div>;
    }

    if (error) {
        return <div className="container error-message">{error}</div>;
    }

    return (
        <div className="unregistered-list-container">
            <h2 className="title">
                {event?.eventName || "イベント"} の未登録者リスト
            </h2>
            <div className="total-count">
                未登録者数: <strong>{unregisteredParticipants.length}</strong> 人
            </div>

            {unregisteredParticipants.length === 0 ? (
                <p className="no-data-message">該当する未登録者はいません。</p>
            ) : (
                <div className="table-wrapper">
                    <table className="unregistered-table">
                        <thead>
                            <tr>
                                <th>社員ID</th>
                                <th>氏名</th>
                                <th>部署名</th>
                                <th>社員区分</th>
                            </tr>
                        </thead>
                        <tbody>
                            {unregisteredParticipants.map((p, index) => (
                                <tr key={index}>
                                    <td>{p.memberId}</td>
                                    <td>{p.employeeName}</td>
                                    <td>{p.departmentName}</td>
                                    <td>{p.employeeType}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            
      <div className="button-group">
        <button type="button" className="btn-print" onClick={handlePrint}>印刷</button>
        <button type="button" className="btn-back" onClick={() => navigate("/event/list")}>戻る</button>
      </div>
        </div>
    );
};

export default UnregisteredList;